import { FormKey } from '@common/formly/types';
import { Constructable } from 'morphism/dist/types/types';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { formsMap } from '@common/formly/constants';

export function Form<T>(
  key: FormKey,
  config: FormlyFieldConfig[]
): (target: Constructable<T>) => void {
  return target => {
    const name = target.name;

    if (!formsMap.has(name)) {
      formsMap.set(name, new Map<FormKey, FormlyFieldConfig[]>());
    }

    const formMapForTarget = formsMap.get(name);

    formMapForTarget.set(key, config);
  };
}
